import EDC from '../../../shared/globals';

EDC.Animations.Birds = function (scene) {
  this.scene = scene;
  this.group = null;
};

EDC.Animations.Birds.prototype.addBird = function () {
  const bird = this.scene.add.sprite(-43, this.getRandomHeight(), 'bird');
  bird.play('birdFly');

  this.scene.tweens.add({
    targets: bird,
    x: this.scene.game.config.width + bird.width,
    duration: 7000,
    ease: 'Linear',
    onComplete: this.destroyBird.bind(this, bird),
  });

  this.group.add(bird);
  this.generateBirdAfterRandomTime();
};

EDC.Animations.Birds.prototype.getRandomHeight = function () {
  const min = 50;
  const max = 590 - min;
  const randomHeight = min + Math.round(Math.random() * max);
  return randomHeight;
};

EDC.Animations.Birds.prototype.start = function () {
  this.group = this.scene.add.container(0, 0);
  this.addBird();
};

EDC.Animations.Birds.prototype.generateBirdAfterRandomTime = function () {
  const time = 1000 * 3 + Math.round(Math.random() * (1000 * 5));
  this.scene.time.addEvent({ delay: time, callback: this.addBird, callbackScope: this });
};

EDC.Animations.Birds.prototype.destroyBird = function (bird) {
  bird.destroy();
};

export default EDC.Animations.Birds;
